// extracted by mini-css-extract-plugin
export default {"navigationItemClicked":"NavigationItem_navigationItemClicked__Cuo08","navigationItem":"NavigationItem_navigationItem__ELvpw"};